import React from "react";
import styled from "styled-components";

import { LibraryView } from "common/constants";
import PresentationLibraryAvatarMenu from "js/editor/PresentationLibrary/PresentationLibraryAvatarMenu";
import NotificationsLabel from "js/editor/PresentationLibrary/NotificationsLabel";
import HelpMenu from "js/editor/components/HelpMenu";
import PresentationLibraryViewSelect from "js/editor/PresentationLibrary/PresentationLibraryViewSelect";
import { FlexSpacer } from "js/react/components/Gap";

export const PRESENTATION_LIBRARY_VIEW_SELECT_WIDTH = 94;

const SideBarColumns = styled.div`
    display: flex;
    height: 100%;
    background: #222;
    width: 100%;
`;

const SideBarSelectColumn = styled.div`
    width: ${PRESENTATION_LIBRARY_VIEW_SELECT_WIDTH}px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
`;

const SideBarContentColumn = styled.div`
    min-width: 0;
    flex: 1;
    background: #333334;
    padding: 16px;
    display: flex;
    flex-direction: column;
`;

const SelectColumnBottomActions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    color: #FFF;
    flex-shrink: 0;
    width: 100%;
    padding-bottom: 20px;
`;

export function PresentationLibrarySideBarLayout({
    libraryView,
    onSwitchType,
    isMyPresentationsOnly = false,
    showViewSelect = true,
    isSideBarContentVisible = true,
    children
}) {
    const showSideBarContent = libraryView !== LibraryView.MY_RESOURCES && isSideBarContentVisible;

    return (
        <SideBarColumns>
            {showViewSelect && (
                <SideBarSelectColumn>
                    <PresentationLibraryViewSelect
                        libraryView={libraryView}
                        onSwitchType={onSwitchType}
                        isMyPresentationsOnly={isMyPresentationsOnly}
                    />
                    <FlexSpacer />
                    <SelectColumnBottomActions>
                        <HelpMenu useOutlineIcon />
                        <NotificationsLabel />
                        <PresentationLibraryAvatarMenu />
                    </SelectColumnBottomActions>
                </SideBarSelectColumn>
            )}
            {showSideBarContent && children && (
                <SideBarContentColumn>
                    {children}
                </SideBarContentColumn>
            )}
        </SideBarColumns>
    );
}
